const profile = {

	dataSource: null,
	filters: {
		type: 'leadership',
		region: '',
		pageindex: '0',
		pagesize: '12'
	},
	results: null,
	
	elem: {
		component: document.querySelector('.profile'),
		$type: $('.profile__type'),
		$region: $('.profile__region'),
		$loading: $('.profile__loading'),
		$count: $('.profile__count'),
		$items: $('.profile__items'),
		$pagination: $('.profile__pagination')
	},

	init() {
		if (profile.elem.component !== null) {
			profile.dataSource = profile.elem.component.getAttribute('data-src');
			this.getQuery();
			this.setControls();
			this.setQuery(false);
		}
	},

	// rebind functions to filters after successfully updating the state
	bindUIActions() {
		this.elem.$type.find('input[type="radio"]').on('change', this.filterRadio);
		this.elem.$region.find('input[type="radio"]').on('change', this.filterRadio);
	},

	// unbind UI from the filters while in the process of updating the state
	unbindUIActions() {
		this.elem.$type.find('input[type="radio"]').off('change');
		this.elem.$region.find('input[type="radio"]').off('change');
	},

	// build a query string from the filters
	buildQuery() {
		let data = this.filters;
		let query = [];
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				if (Array.isArray(key)) {
					data[key] = key.toString();
				}
				query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
			}
		}
		query = query.join('&').replace(/%2C/g, ',');
		return query;
	},

	// filtering on pagination click
	filterPagination(e) {
		e.preventDefault();
		profile.filters['pageindex'] = e.currentTarget.hash.substr(1);
		profile.setQuery(true, true);
		$('html, body').animate({ scrollTop: $('.profile').offset().top }, 100);
	},	
	
	// filtering on radio change
	filterRadio(e) {
		e.preventDefault();
		let key = e.currentTarget.name;
		let value = e.currentTarget.value;
		let status = e.currentTarget.checked;
		if(key === 'type') {
			profile.filters['region'] = '';
			profile.elem.$region.find('input[type="radio"]').prop('checked',false);
			profile.elem.$region.find('input[type="radio"][value=""]').prop('checked',true);
		}
		if(status) {
			profile.filters[key] = value;
		} else {
			profile.filters[key] = '';
		}
		profile.filters['pageindex'] = 0;
		profile.setQuery(true);
	},	

	// get data
	getData(query) {
		let deferred = $.Deferred();
		$.ajax({
			url: profile.dataSource,
			method: 'GET',
			data: query,
			dataType: 'html',
			success: function(data) {
				deferred.resolve(data);
			},
			error: function(jqXHR, textStatus, errorThrow) {
				console.log(jqXHR, errorThrow);
				deferred.reject(textStatus);
			}
		});
		return deferred.promise();
	},	
	
	// overwrite default filter settings with values passed through query string, ignoring blank values and values without a filter
	getQuery() {
		if (window.location.search.length > 0) { 
			let searchParams = new URLSearchParams(window.location.search);
			searchParams.forEach(function (value,key) {
				if(value !== '') {
					if(profile.filters[key] !== undefined) {					
						if (Array.isArray(profile.filters[key])) {
							profile.filters[key] = [];
							value = value.split(',');
							profile.filters[key] = value;
						} else {
							profile.filters[key] = value;
						}
					}
				}
			});
		}
	},

	// build and render count from retrieved results
	renderCount() {
		let output = parseInt(profile.filters['pageindex']) * parseInt(profile.filters['pagesize']) + 1;
		let maxCount = output + parseInt(profile.filters['pagesize']) - 1;
		if (maxCount > profile.results.TotalCount) {
			maxCount = profile.results.TotalCount;
		}
		if (parseInt(maxCount) !== 1) {
			output += ' to ';
			output += maxCount;
			output += ' of ';
			output += profile.results.TotalCount;
		} else {
			output += ' Result';
		}
		profile.elem.$count.html(output);
	},

	// build and render pagination from retrieved results
	renderPagination() {
		let items = [];
		let filters = profile.filters;
		let current = parseInt(filters['pageindex']);
		let max = Math.ceil(parseInt(profile.results.TotalCount) / parseInt(filters['pagesize'])) - 1;
		let output = '<ul class="pagination__list" aria-label="Pagination">';
		items.push(0, current - 1, current, current + 1, max);
		if (current < 2) {
			items.push(2);
		}
		if (current > (max - 1)) {
			items.push(max - 2);
		}
		items = items.filter(function(x){ return x > -1 });
		items = items.filter(function(x){ return x <= max });
		items = [...new Set(items)];
		items = items.sort(function(a, b){return a-b});
		output += '<li class="pagination__item pagination__item--prev"><a href="#' + (current - 1) + '" class="pagination__button icon-btn icon-btn--no-circle';
		if(current === 0) {
			output += ' icon-btn--disabled" tabindex="-1';
		}
		output += '" rel="prev"><svg class="brei-icon brei-icon-chevron-s" focusable="false"><use href="#brei-icon-chevron-s"></use></svg><span class="show-for-sr">Previous Page</span></a></li>';

		// individual profile
		for(let i = 0; i < items.length; i = i + 1) {
			if((i === 0) || (items[i] !== items[i - 1])) {
				if((i > 0) && ((items[i] - items[i - 1]) > 1)) {
					output += '<li class="pagination__item"><span class="pagination__span">...</span></li>';
				}
				if(items[i] === current) {
					output += '<li class="pagination__item pagination__item--active"><a href="#' + items[i] + '" class="pagination__link" tabindex="-1"><span class="show-for-sr">You\'re on page</span> ' + (items[i] + 1) + '</a></li>';
				} else {
					output += '<li class="pagination__item"><a href="#' + items[i] + '" class="pagination__link" aria-label="Page ' + (items[i] + 1) + '">' + (items[i] + 1) + '</a></li>';
				}
			}
		}
		// next button
		output += '<li class="pagination__item pagination__item--next"><a href="#' + (current + 1) + '" class="pagination__button icon-btn icon-btn--no-circle';
		if(current === max) {
			output += ' icon-btn--disabled" tabindex="-1';
		}
		output += '" rel="next"><svg class="brei-icon brei-icon-chevron-s" focusable="false"><use href="#brei-icon-chevron-s"></use></svg><span class="show-for-sr">Next Page</span></a></li></ul>';
		profile.elem.$pagination.html(output);
		$('.pagination__button, .pagination__link').on('click', profile.filterPagination);
	},	
	
	renderResults() {
		if(profile.filters['type'] === 'directors') {
			profile.elem.$region.show();
		} else {
			profile.elem.$region.hide();
		}
		profile.elem.$loading.hide();
		let content = '';
		profile.renderCount();
		profile.elem.$count.fadeIn();		
		profile.results.Results.forEach(function(item) {
			content += `<div class="card-profile" itemscope itemtype="https://schema.org/Person"><a href="${item.link}" class="btn-link" itemprop="url"><span class="show-for-sr">Read ${item.name}'s bio</span></a><figure class="card-profile__figure" itemprop="image" itemscope="" itemtype="https://schema.org/ImageObject"><img src="${item.image}" alt="${item.name}" class="card-profile__image" width="234" height="234" itemprop="url contentUrl" loading="lazy"></figure><div class="card-profile__content"><h3 class="card-profile__heading" itemprop="name">${item.name}</h3><p class="card-profile__info"><span itemprop="jobTitle">`;
			item.title.forEach(function(line) {
				content += `<br>${line}`;
			});
			content += '</span></p><p aria-hidden="true" class="nav-link nav-link--secondary">Read Bio</p></div></div>';
		});
		profile.elem.$items.html(content);
		profile.elem.$items.show();
		if(profile.results.TotalCount > profile.filters['pagesize']) {
			profile.renderPagination();
			profile.elem.$pagination.fadeIn();
		}
	},

	// update filters elements based on filters
	setControls() {
		profile.unbindUIActions();
		for (let key in profile.filters) {
			if (profile.filters.hasOwnProperty(key)) {
				for (let i = 0; i < profile.filters[key].length; i = i + 1) {
					let item = $('[id^="' + key + '"][value="' + profile.filters[key] + '"]');
					item.prop('checked',true);
				}
			}
			if((key === 'type') && (profile.filters[key] === 'directors')) {
				profile.elem.$region.hide();
			}
		}
		profile.bindUIActions();
	},		
		
	// update queryString based on filters
	setQuery(push) {
		let query = profile.buildQuery();
		let dataObj = profile.getData(query);
		if (push === true) {
			history.pushState(null, '', '?' + query);
		} else {
			history.replaceState(null, '', '?' + query);
		}		
		profile.elem.$loading.show();
		profile.elem.$count.fadeOut().empty();
		profile.elem.$items.fadeOut().empty();
		profile.elem.$pagination.fadeOut().empty();
		$.when(dataObj)
			.done(function(data) {
				setTimeout(function() {
					profile.results = JSON.parse(data);
					profile.renderResults();
				}, 500);
			})
			.fail(function () {
				console.log('API ERROR: No results were returned')
			});
	}

};

export { profile };
